var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneySmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.23122 1.23122 0 2.75 0H12.75C14.2688 0 15.5 1.23122 15.5 2.75V4H16.75C18.2688 4 19.5 5.23122 19.5 6.75V12.75C19.5 14.2688 18.2688 15.5 16.75 15.5H6.75C5.23122 15.5 4 14.2688 4 12.75V11.5H2.75C1.23122 11.5 0 10.2688 0 8.75V2.75ZM5.5 12.75C5.5 13.4404 6.05964 14 6.75 14H16.75C17.4404 14 18 13.4404 18 12.75V6.75C18 6.05964 17.4404 5.5 16.75 5.5H6.75C6.05964 5.5 5.5 6.05964 5.5 6.75V12.75ZM14 4H6.75C5.23122 4 4 5.23122 4 6.75V10H2.75C2.05964 10 1.5 9.44036 1.5 8.75V2.75C1.5 2.05964 2.05964 1.5 2.75 1.5H12.75C13.4404 1.5 14 2.05964 14 2.75V4ZM11.75 8.5C11.0596 8.5 10.5 9.05964 10.5 9.75C10.5 10.4404 11.0596 11 11.75 11C12.4404 11 13 10.4404 13 9.75C13 9.05964 12.4404 8.5 11.75 8.5ZM9 9.75C9 8.23122 10.2312 7 11.75 7C13.2688 7 14.5 8.23122 14.5 9.75C14.5 11.2688 13.2688 12.5 11.75 12.5C10.2312 12.5 9 11.2688 9 9.75Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySmall);
export default __webpack_public_path__ + "static/media/money-small.63b43f51f5850a5c1c0ff413130fea5b.svg";
export { ForwardRef as ReactComponent };